import { Card, CardContent, Grid, Typography } from "@mui/material";
import { CssTextField } from "./CommonStyles";
import Autocomplete from "./AutocompleteComponent";

const InvoiceAddressComponent = ({
  post,
  isInteralOrAdminUser,
  divisionId,
  user_id,
  searchParams,
  handleOptionSelection,
}) => (
  <Grid item xs={12} sm={6} md={4}>
    <label className="headingstyle">
      <h5>
        <b>Billing Address</b>
      </h5>
    </label>
    <Card variant="outlined">
      {isInteralOrAdminUser && (
        <Grid item xs={2}>
          {/* Autocomplete for internal/admin users */}
          <Autocomplete
            divisionId={divisionId}
            onOptionSelect={handleOptionSelection}
            isRequired={isInteralOrAdminUser}
            userId={user_id}
            searchParams={searchParams}
          />
        </Grid>
      )}
      <CardContent sx={{ margin: 0 }}>
        <CssTextField
          type="text"
          fullWidth
          value={post?.customer_name || ""}
          style={{
            color: "black",
            fontWeight: "normal",
            fontSize: "small",
          }}
          inputProps={{
            style: {
              color: "black",
              fontWeight: "normal",
              fontSize: "small",
            },
          }}
          disabled
          readOnly
          variant="standard"
        />
        <Card sx={{ minWidth: 275 }}>
          <CardContent>
            {[
              "customer_address1",
              "customer_address2",
              "customer_address3",
              "customer_address4",
              "customer_post_code",
            ].map((field) => (
              <Typography
                key={field}
                style={{ fontSize: "12px", fontWeight: 200 }}
              >
                {post?.[field]}
              </Typography>
            ))}
          </CardContent>
        </Card>
      </CardContent>
    </Card>
  </Grid>
);

export default InvoiceAddressComponent;
